(() => {
  const clean = (value) => String(value == null ? "" : value).replace(/[<>]/g, "").trim();
  const track = (event, payload = {}) => {
    try { return window.AvonticAnalytics?.track?.(event, payload); }
    catch (_) { return false; }
  };

  const setupHub = (root) => {
    const input = root.querySelector("[data-avj-search]");
    const cards = [...root.querySelectorAll("[data-avj-card]")];
    const filters = [...root.querySelectorAll("[data-avj-filter]")];
    const status = root.querySelector("[data-avj-status]");
    const empty = root.querySelector("[data-avj-empty]");
    let category = "all";

    const render = () => {
      const query = clean(input ? input.value : "").toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const haystack = clean(card.dataset.search).toLowerCase();
        const cardCategory = clean(card.dataset.category).toLowerCase();
        const show = (!query || haystack.includes(query)) && (category === "all" || cardCategory === category);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (status) status.textContent = visible + " " + (visible === 1 ? root.dataset.copyGuide : root.dataset.copyGuides);
      if (empty) empty.hidden = visible !== 0;
    };

    if (input) {
      input.addEventListener("input", render);
      input.addEventListener("change", () => track("journal_search_used", { query: clean(input.value) }));
    }
    filters.forEach((button) => {
      button.addEventListener("click", () => {
        category = clean(button.dataset.avjFilter).toLowerCase();
        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });
        track("journal_filter_selected", { category });
        render();
      });
    });
    render();
    track("journal_viewed", { articles: cards.length });
  };

  const setupArticle = (root) => {
    const body = root.querySelector("[data-avj-article-body]");
    const list = root.querySelector("[data-avj-toc-list]");
    if (body && list) {
      [...body.querySelectorAll("table")].forEach((table) => {
        if (table.parentElement && table.parentElement.classList.contains("table-wrapper")) return;
        const wrapper = document.createElement("div");
        wrapper.className = "table-wrapper";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.append(table);
      });
      const headings = [...body.querySelectorAll("h2")];
      headings.forEach((heading, index) => {
        const id = heading.id || "journal-section-" + (index + 1);
        heading.id = id;
        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = "#" + id;
        link.textContent = String(index + 1).padStart(2, "0") + " " + clean(heading.textContent);
        item.append(link);
        list.append(item);
      });
      const toc = root.querySelector("[data-avj-toc]");
      if (toc) toc.hidden = headings.length === 0;
    }
    track("journal_article_viewed", {
      article: clean(root.dataset.articleHandle),
      category: clean(root.dataset.articleCategory),
    });
  };

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-avj-track]");
    if (!link) return;
    track(clean(link.dataset.avjTrack), {
      article: clean(link.dataset.article),
      destination: clean(link.getAttribute("href")),
      product_handle: clean(link.dataset.productHandle),
    });
  });

  const boot = () => {
    document.querySelectorAll("[data-avj-hub]").forEach(setupHub);
    document.querySelectorAll("[data-avj-article]").forEach(setupArticle);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
